
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"path-1",attrs:{"fill":"#000","fill-rule":"evenodd","d":"M15.35 10.1l-5.06 5.11-1.73-1.76a.33.33 0 00-.56.24c0 .08.03.17.1.23l1.99 2a.3.3 0 00.25.08.68.68 0 00.26-.08l5.3-5.33a.3.3 0 000-.45.39.39 0 00-.55-.04z","clip-rule":"evenodd"}}),_c('path',{staticClass:"path-2",attrs:{"fill":"#000","fill-rule":"evenodd","d":"M15.06 2.09C15.01 2 14.9 2 14.8 2H6.4a1.3 1.3 0 00-.98.41A1.46 1.46 0 005 3.44v17.08a1.53 1.53 0 00.4 1.04 1.37 1.37 0 00.96.44H17.6a1.3 1.3 0 00.99-.41 1.46 1.46 0 00.41-1.03V6.46a.8.8 0 00-.08-.3L15.06 2.1zm3.12 4.34H15.5a.69.69 0 01-.5-.2.77.77 0 01-.2-.53V2.87l3.38 3.56zm-.58 14.82H6.4a.69.69 0 01-.5-.21.77.77 0 01-.21-.52V3.48c0-.2.07-.38.2-.52s.3-.22.49-.23h7.72v2.96c0 .39.14.76.4 1.04.25.28.6.45.97.45h2.84v13.34c0 .2-.07.38-.2.52a.69.69 0 01-.49.23l-.02-.02z","clip-rule":"evenodd"}})])
          )
        }
      }
    